import type { ReactNode } from 'react'
import { Navigate } from '@tanstack/react-router'
import { useMe } from '../lib/use-me'
import { canViewExecutive } from '../lib/permissions'

/**
 * Renders children only for clevel+ roles. While the role is loading we render
 * nothing (avoids a flash of the gated screen, which would 403 for `user`).
 * `user` is redirected to the dashboard.
 */
export function RoleGuard({ children }: { children: ReactNode }) {
  const me = useMe()
  if (me.isLoading || !me.data) return null
  if (!canViewExecutive(me.data.role)) return <Navigate to="/" />
  return <>{children}</>
}
